import React, { useState, useEffect } from "react";
import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import { useSelector } from 'react-redux';
import {useNavigate} from "react-router-dom";
import Grid from '@mui/material/Grid';
import {readEmpty} from "../../pages/SalesMeeting/apiEmpty.js";
import "./style.css";
import { Select, MenuItem } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import axios from "axios";
import Button from '@mui/material/Button';
import { Typography, Dialog, LinearProgress, DialogContent, Box } from "@mui/material";
import TextField from '@mui/material/TextField';
import Autocomplete from "@mui/material/Autocomplete";
import CheckIcon from "@mui/icons-material/Check";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import {Switch} from "@mui/material";
export default function LegalProcess() {
    
    // Add a state variable to hold the selected file
    const [file, setFile] = useState(null);
    const [selectedSales, setSelectedSales] = useState([]);
    const [selectedLokasi, setSelectedLokasi] = useState([]);

    // Handle file selection
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };
    const [imageUrl, setImageUrl] = useState(null); // State to hold the URL of the image
    const navigate = useNavigate();
    const getURL = () => {
        if (!file) {
            alert("Please select a file to upload.");
            return;
        }
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/getUploadURL`)
            .then(response => {
                const uploadUrl = response.data.url;
                const key = response.data.key; // assuming this is returned by your API
    
                fetch(uploadUrl, {
                    method: "PUT",
                    headers: {
                        "Content-Type": file.type // Use the type of the selected file
                    },
                    body: file
                })
                .then(response => {
                    if (!response.ok) { throw response }
    
                    // Fetch the file from your backend using the `key`
                    axios.get(`${process.env.REACT_APP_BACKEND_URL}/getFile?filename=${encodeURIComponent(key)}`, {
                        responseType: 'blob' // Tell axios to get the response as a blob
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'file.pdf'); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                        const file = new Blob([response.data], {type: 'application/pdf'});
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
                    })
                    .catch(error => {
                        console.error("Error during file retrieval:", error);
                    });
                })
                .catch(error => {
                    console.error("Error during file upload:", error);
                });
            });
    }
    
    const [date,setDate]= useState(new Date())
    const [dateEnd,setDateEnd]= useState(new Date())
    
    const nowstate = useSelector(state => state);
    const [judul,setJudul] = useState();
    const [posts, setPosts] = useState([])
    const [randomposts, setRandomposts] = useState([])

    const [lokasi, setLokasi]= useState(["Lokasi Sendiri","VO Kokas", "VO G.Serpong", "VO Duta Merlin", "VO Bekasi", "PO Kokas", "PO G.Serpong", "PO Duta Merlin", "PO Bekasi"])
    const [checkedState, setCheckedState] = useState({
        'Pendirian PT': false,
        'Pendirian CV': false,
        'PT Perorangan': false,
        'PKP': false,
        'SIUJK': false,
        'IUPJPT': false,
        'Izin Khusus': false,
        'Jual Beli Saham': false,
        'Ganti Pengurus': false,
        'Mutasi Alamat': false,
        'Perubahan KBLI': false,
        'Update OSS RBA': false,
        'Pendaftaran Merek': false,
        // Add more checkboxes as needed
    });

    const handleChange = (event) => {
        setCheckedState({ ...checkedState, [event.target.name]: event.target.checked });
    };
    const [bDate,setbDate] = useState(Date())
    const [endDate,setendDate] = useState(Date(Date.now() + 1 * 24 * 60 * 60 * 1000))
    const [startDate, setStartDate] = useState(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) // 7 days before the current date
    const [state, setState] = useState({
        gilad: false,
        jason: false,
        antoine: true,
      });

      const [status,setStatus] = useState("PMDN")
      const handleDateChange = (event) => {
        setbDate(event);
    }
      const switchChange = (event) => {
        setSelectedSales("")
        setState({
          ...state,
          [event.target.name]: event.target.checked,
        });
        if(status === "PMDN"){
          setStatus("PMA")
        }else{
          setStatus("PMDN")
        }
      }
      const previewInquiry = async (post) => {
        console.log("test")
        console.log(post)
        if (post.management.stat === "Done"){}else{
        const clickedPosts = posts.map(p => {
            if (p._id === post._id) {
              // Update the management.stat for the clicked post
              return { ...p, management: { ...p.management, stat: "Checked" } };
            }
            return p;
          });
          setPosts(clickedPosts);
    // Convert the post object to a string to store in local storage
   axios.post(`${process.env.REACT_APP_BACKEND_URL}/clickedsalesmeeting`,{
        id: post._id, filterThis:filterThis
    })}
    const postString = JSON.stringify(post);

    // Use a unique key for this particular piece of data
  localStorage.setItem('currPreview', postString);
  // Open a new tab. The URL should be the route where you handle the preview.
  // Assuming you have a route like '/preview' set up for this
  window.open('/#/specificcase', '_blank');
    }
    const [isEnd,setIsEnd] = useState("loading..")

    const previewRandomizer = async (post) => {
        console.log("test")
        console.log(post)
    const postString = JSON.stringify(post);

    // Use a unique key for this particular piece of data
  localStorage.setItem('currPreview', postString);
  // Open a new tab. The URL should be the route where you handle the preview.
  // Assuming you have a route like '/preview' set up for this
  window.open('/#/specificrandomizer', '_blank');
    }

      const [loadVisibility, setLoadVisibility] = useState(false)
      const saveLegal = () => {
        setLoadVisibility(true)       
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/saveLegal1`, {
            
          })
          .then(response => {
                    
            
            }).catch(err => {
                console.error(err);
            }); 
        }

        const [filterThis, setfilterThis] = useState("Extend")
        const commonStyles = {
            border: 1,
          };
        const [sales, setSales] = useState("Semua")
        const [skip,setSkip] = useState(0)
        async function randomize() {
            try {
                const responsess = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/randomize?startDate=${startDate}&endDate=${endDate}`);
                console.log(responsess.data);
                setRandomposts([])
                setRandomposts(responsess.data)
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        const setSalesNow = async (event) => {
            setSales(event.target.value)
            try{
                setPosts([])
                const data = await readEmpty(event.target.value, filterThis, startDate, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        const setStartDateNow = async (event) => {
            setStartDate(event)
            try{
                setPosts([])
                const data = await readEmpty(sales, filterThis, event, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        const setendDateNow = async (event) => {
            setendDate(event)
            try{
                setPosts([])
                const data = await readEmpty(sales, filterThis, startDate, event);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        const setfilterThisNow = async (event) => {
            setfilterThis(event.target.value)
            try{
                setPosts([])
                const data = await readEmpty(sales, event.target.value, startDate, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
        }
        useEffect(() => {
            fetchPosts();
        },[skip]);
        const newFetchPosts = async (event) => {
            setPosts([])
            setIsEnd("Loading...");
                try{
                    const { data, error } = await readEmpty(sales, filterThis, startDate, endDate);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    console.log(data)
    
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                } 
        }

        
        const fetchPosts = async () => {

    
            try{
                const data = await readEmpty(sales, filterThis, startDate, endDate);
                console.log(data)
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                console.log(data)
    
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            } 
            
        }
    
    return (
        <Grid container>
                <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Grid item  xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid xl={11.5} lg={11.3} md={10.4} sm={8.8} >
                <Grid className="boxshadowclass" position="fixed" width="98%" xs={12} zIndex="100" opacity="1">
                <Header judul="Sales Meeting" isi="Legal Baru"></Header>
                </Grid>
                <Grid sx={{ mt:15}}></Grid>
                                 {/*........................................................Untuk legal Vieww/Dashboard yaaaaaaa .........................................................................................................................................*/}
                                 <>
        {nowstate.user.role==="owner" && (
          <>
                <Grid container sx={{pl:10, pt:5}} xs={12}>
                    <Grid xs={4}>
                    <Select  fullWidth value={filterThis} onChange={event => setfilterThisNow(event)}><MenuItem value="Extend">Extend</MenuItem><MenuItem value="Inquiry">Inquiry</MenuItem></Select>
                    </Grid>
                    <Grid xs={1}></Grid>
                    <Grid xs={4}>
                    <Select  fullWidth value={sales} onChange={event => setSalesNow(event)}><MenuItem value="Semua">Semua</MenuItem><MenuItem value="Adnan">Adnan</MenuItem><MenuItem value="Felly">Felly</MenuItem></Select>
                    </Grid>
                </Grid>
                <Grid container sx={{pl:10, pb:5}} xs={12}>
                    <Grid xs={4}>
                    <LocalizationProvider color="#FFFFFF" dateAdapter={AdapterDateFns}>
                    <MobileDatePicker views={['day','month', 'year']} color="#FFFFFF" inputFormat="dd/MM/yyyy"
                        placeholder="Tanggal"
                        value={startDate}
                        onChange={(event) => {
                            setStartDateNow(event);
                        }}
                        renderInput={(params) => <TextField fullWidth  {...params} InputProps={{endAdornment: (
                        <InputAdornment color="#FFFFFF" position="end">
                            <CalendarMonthIcon />
                        </InputAdornment>
                    ),
                    }}/>}

                        />
                        </LocalizationProvider></Grid>
                    <Grid xs={1}></Grid>
                    <Grid xs={4}>
                    <LocalizationProvider color="#FFFFFF" dateAdapter={AdapterDateFns}>
                    <MobileDatePicker views={['day','month', 'year']} color="#FFFFFF" inputFormat="dd/MM/yyyy"
                        placeholder="Tanggal"
                        value={endDate}
                        onChange={(event) => {
                            setendDateNow(event);
                        }}
                        renderInput={(params) => <TextField fullWidth  {...params} InputProps={{endAdornment: (
                        <InputAdornment color="#FFFFFF" position="end">
                            <CalendarMonthIcon />
                        </InputAdornment>
                    ),
                    }}/>}

                        />
                        </LocalizationProvider>
                    
                    </Grid>
                    <Grid container align = "center" sx={{pr:5, pt:5}} justify = "center" alignItems = "center">

                    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 300, minHeight: 300 }} className="min-h-screen h-screen overflow-scroll">
                            <Table stickyHeader aria-label="sticky table">
                                <TableBody>
                                    {posts && posts.length > 0 ? (
                                        posts.map((post) => (
                                            <TableRow hover key={post.id}> {/* Ensure to use a unique key for each row */}
                                            <TableCell sx={{ ...commonStyles, borderColor: 'grey.100', 
                                            backgroundColor: (theme) => 
                                            post.management && post.management.stat === 'Done' ? 'lightgreen' :
                                            post.management && post.management.stat === 'Checked' ? 'lightblue' : 
                                            'inherit',
                                             }} onClick={() => previewInquiry(post)} style={{ cursor: 'pointer' }}>
                                                {
                                                filterThis === 'Extend' ?
                                                    (post.tipe === 'Virtual Office' ?
                                                    `Virtual Office ${post.data.CompanyName} ${post.notes} (${post.stat ?? "not yet"})` :
                                                    post.tipe === 'Private Office' ?
                                                    `Private Office ${post.data.CompanyName} ${post.notes} (${post.stat ?? "not yet"})` :
                                                    'N/A') :
                                                    `${post.Phone} (${post.Sales})`
                                                }
                                            </TableCell>
                                                
                                                {/* Other TableCell components */}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                                Done
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {isEnd && (
                                        <TableRow>
                                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                                
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Paper>
                    </Grid>
                    <Grid xs={12} sx={{my:5}}>
                        <h1><b>Randomizer</b></h1>
                    </Grid>

                    <Grid xs={12} lg={3} >
                            Dari: 
                            <LocalizationProvider dateAdapter={AdapterDateFns}>

                                                    <MobileDatePicker 
                                                        views={['year', 'month', 'day']}
                                                        inputFormat="dd/MM/yyyy"
                                                        value={date}
                                                        onChange={(value)=>setDate(value)}
                                                        renderInput={(params) => 
                                                            <TextField 
                                                                {...params} 
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment >
                                                                            <CalendarMonthIcon />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        }
                                                    />

                                        </LocalizationProvider>
                                        </Grid>
                                        <Grid  xs={12} lg={3}>
                            Sampai:
                            <LocalizationProvider dateAdapter={AdapterDateFns}>

                                                    <MobileDatePicker 
                                                        views={['year', 'month', 'day']}
                                                        inputFormat="dd/MM/yyyy"
                                                        value={dateEnd}
                                                        onChange={(value)=>setDateEnd(value)}
                                                        renderInput={(params) => 
                                                            <TextField 
                                                                {...params} 
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment >
                                                                            <CalendarMonthIcon />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                        }
                                                    />

                                        </LocalizationProvider>
                    </Grid>
                        <Grid xs={12} lg={3} >
                           <Button variant="contained" onClick={event => randomize()}>Randomizer</Button>
                        </Grid>

                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                        <TableContainer sx={{ maxHeight: 300, minHeight: 300 }} className="min-h-screen h-screen overflow-scroll">
                            <Table stickyHeader aria-label="sticky table">
                                <TableBody>
                                    {randomposts && randomposts.length > 0 ? (
                                        randomposts.map((post) => (
                                            <TableRow hover key={post.id}> {/* Ensure to use a unique key for each row */}
                                            <TableCell sx={{ ...commonStyles, borderColor: 'grey.100', 
                                           
                                             }} onClick={() => previewRandomizer(post)} style={{ cursor: 'pointer' }}>
                                                {
                                                filterThis === 'Extend' ?
                                                    (post.tipe === 'Inquiry' ?
                                                    `Inquiry ${post.Sales} info: ${post.notes}; Nomor: ${post.activityDetail.Phone} ` :
                                                    post.tipe === 'Remind' ?
                                                    `Remind ${post.Sales}; ${post.activityDetail.data.TipeKontrak} ${post.activityDetail.data.CompanyName}; info: (${post.notes??""})` :
                                                    'N/A') :
                                                    `${post.Phone} (${post.Sales})`
                                                }
                                            </TableCell>
                                                
                                                {/* Other TableCell components */}
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                                Done
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    {isEnd && (
                                        <TableRow>
                                            <TableCell colSpan={5} style={{ textAlign: "center" }}>
                                                
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Paper>
                </Grid>
                </>)}</>
               
        
            </Grid>
        </Grid>
    );
}
